import type { FaireProductEntity } from "../../entity_types/product";

export const nopalera_5: FaireProductEntity = {
  token: "nopalera-5",
  type: "product",
  name: "Tepoztlán Candle",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/537ef45e477c04975db20750e65f4efd9ccdea2b4dbf2a2115481367c879c4ad.webp",
  priceDollars: 28,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.7,
  dimensions: {
    width: 3,
    height: 4,
    depth: 3,
  },
  description: "Tepoztlán candle - Nopalera bestseller",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "candle", "latinx"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
